import { IconOutgoingMail, IconSend } from "@/assets/icons";
import { DetailFooterShell } from "@/components/commons/DetailFooterShell";
import { Button } from "@/components/elements/Button";
import { Stack } from "@mui/material";
import { FC } from "react";

type TEmailChangeReviewFooterProps = {
  onBack: () => void;
  onSend: () => void;
  onResend: () => void;
  isSending?: boolean;
  // Resend is only meaningful after the first send; disabled until then.
  hasSent?: boolean;
  // Seconds left before resend is allowed again (0 = ready). Set after each send to throttle re-clicks.
  resendCooldown?: number;
};

// Footer for the review step (Hình 2). Only one action shows at a time:
// before the first send → 認証メールを送信; after → メールの再送信 (throttled by cooldown).
export const EmailChangeReviewFooter: FC<TEmailChangeReviewFooterProps> = ({
  onBack,
  onSend,
  onResend,
  isSending = false,
  hasSent = false,
  resendCooldown = 0,
}) => {
  const resendLabel = resendCooldown > 0 ? `メールの再送信（${resendCooldown}秒）` : "メールの再送信";

  return (
    <DetailFooterShell>
      <Button variant="ghost" size="sm" type="button" onClick={onBack}>
        戻る
      </Button>
      {hasSent ? (
        <Button variant="secondary" size="sm" type="button" disabled={isSending || resendCooldown > 0} onClick={onResend}>
          <Stack direction="row" alignItems="center" gap="8px">
            <IconOutgoingMail fontSize={20} />
            {resendLabel}
          </Stack>
        </Button>
      ) : (
        <Button variant="primary" size="sm" type="button" disabled={isSending} onClick={onSend}>
          <Stack direction="row" alignItems="center" gap="8px">
            <IconSend fontSize={20} />
            認証メールを送信
          </Stack>
        </Button>
      )}
    </DetailFooterShell>
  );
};
